import React, { useState, useContext, useEffect } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Container, Nav, Form, InputGroup } from "react-bootstrap";
import {
  Menu,
  User,
  Search,
  Heart,
  ShoppingBag,
  MapPin,
  Home,
} from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";
import { motion, AnimatePresence } from "framer-motion";
 import { useNavigate } from "react-router-dom";

function Header() {
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const { categories } = useContext(CategoryContext);
  const [openId, setOpenId] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
 

const navigate = useNavigate();

const handleNavigate = (path) => {
  const offcanvasEl = document.getElementById("customAxPakhMobileMenu");

  const offcanvas =
    window.bootstrap?.Offcanvas.getInstance(offcanvasEl);

  if (offcanvas) {
    offcanvas.hide();
  }

  setTimeout(() => {
    navigate(path);
  }, 300);
};

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  if (!config) return null;

  const handleModalShow = () => {
    setShowSearchModal(true);
  };

  const navItems = [
    "HOME",
    "SHOP",
    "ABOUT",
    "BLOG",
    "CONTACT US",
  ];

  return (
    <>
      {/* top bar */}
      <section className="custom-ax-pakh-top-bar-sec-head">
        <div className="custom-ax-pakh-top-bar-track">
          <div className="custom-ax-pakh-top-bar-content">
            <div>
              <span className="custom-ax-pakh-top-bar-dot">•</span>
              <span className="custom-ax-pakh-top-bar-item">
                Handwoven Bengal Sarees Crafted with Elegance
              </span>
            </div>
            <div>
              <span className="custom-ax-pakh-top-bar-dot">•</span>
              <span className="custom-ax-pakh-top-bar-item">
                Authentic Cotton, Linen & Jamdani Collections
              </span>

            </div>
            <div>

              <span className="custom-ax-pakh-top-bar-dot">•</span>
              <span className="custom-ax-pakh-top-bar-item">
                Handwoven Bengal Sarees Crafted with Elegance
              </span>

            </div>
            <div>
              <span className="custom-ax-pakh-top-bar-dot">•</span>
              <span className="custom-ax-pakh-top-bar-item">
                Free Shipping on Orders Above
              </span>
            </div>

            <div>
              <span className="custom-ax-pakh-top-bar-dot">•</span>
              <span className="custom-ax-pakh-top-bar-item">
                Authentic Cotton, Linen & Jamdani Collections
              </span>

            </div>

          </div>
        </div>
      </section>












      <header className="custom-ax-pakh-header-nav-sec-wrapper">
        {/* Top Header */}
        <div className="custom-ax-pakh-header-nav-sec-top">
          <div className="container-fluid px-lg-5">
            <div className="row align-items-center">

              {/* Mobile Menu */}
              <div className="col-2 d-lg-none">
                <button
                  className="btn p-0 border-0"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#customAxPakhMobileMenu"
                >
                  <Menu size={18} />
                </button>
              </div>

              {/* Logo */}
              <div className="col-8 col-lg-6">
                <Link
                  to="/"
                  className="custom-ax-pakh-header-nav-sec-logo"
                >
                  <img
                    src={config?.logo}
                    alt="Logo"
                  />
                </Link>
              </div>

              {/* Icons */}
              <div className="col-2 col-lg-6">
                <div className="custom-ax-pakh-header-nav-sec-icons">
                  {/* <button
                    className="btn p-0"
                    onClick={() => setShowSearchModal(true)}
                  >
                    <Search size={32} />
                  </button> */}

                  <div className="custom-search-bar-sec-b-wrapper   d-none d-lg-flex">
                    <Search
                      size={15}
                      className="custom-search-bar-sec-b-icon"
                    />

                    <input
                      type="text"
                      placeholder="Search  ..."
                      className="custom-search-bar-sec-b-input"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>



                   <Link to="/wishlist" className="d-block text-decoration-none">
                <Heart size={22} className="text-dark" strokeWidth={1.5} />
              </Link>

                  <button
                    className="btn p-0 position-relative"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#shoppingCartCanvas"
                  >
                    <ShoppingBag size={22} />

                    <span className="custom-ax-pakh-header-nav-sec-cart-badge">
                      {cartItems.length}
                    </span>
                  </button>
                  {isLoggedIn ? (
                    <Link to="/users/dashboard">
                      <User size={22} />
                    </Link>
                  ) : (
                    <Link to="/users/login">
                      <User size={22} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="custom-ax-pakh-header-nav-sec-bottom d-none d-lg-flex">

          <Link
            to="/"
            className="custom-ax-pakh-header-nav-sec-link"
          >
            Home
          </Link>

          <div className="custom-ax-pakh-header-nav-sec-dropdown">
            <Link
              to="/about-us"
              className="custom-ax-pakh-header-nav-sec-link"
            >
              About
            </Link>
          </div>

          {categories.map((cat) => (
            <div
              key={cat._id}
              className="custom-ax-pakh-header-nav-sec-dropdown"
            >
              <Link
                to={`/categories/${cat.slugPath}`}
                className="custom-ax-pakh-header-nav-sec-link"
              >
                {cat.name}
              </Link>
              {cat.children?.length > 0 && (
                <div className="custom-ax-pakh-header-nav-sec-dropdown-menu">
                  {cat.children.map((sub) => (
                    <Link
                      key={sub._id}
                      to={`/categories/${sub.slugPath}`}
                      className="custom-ax-pakh-header-nav-sec-dropdown-item"
                    >
                      {sub.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}

          <Link
            to="/shop"
            className="custom-ax-pakh-header-nav-sec-link"
          >
            Shop
          </Link>

           <Link
            to="/blog"
            className="custom-ax-pakh-header-nav-sec-link"
          >
          Blog
          </Link>

          <Link
            to="/contact-us"
            className="custom-ax-pakh-header-nav-sec-link"
          >
            Contact Us
          </Link>
        </nav>
      </header>

      <SearchCanvas
        isOpen={true}
        searchText={searchText}
        setSearchText={setSearchText}
      />

      <div
        className="offcanvas offcanvas-end custom-cart-offcanvas"
        id="shoppingCartCanvas"
      >
        <CartCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="loginOffCanvas"
      >
        <LoginCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="registerOffCanvas"
      >
        <RegisterCanvas />
      </div>






      {/* Mobile Menu Offcanvas */}
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="customAxPakhMobileMenu"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">Menu</h5>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <div className="offcanvas-body">

          <Link
            to="/"
            className="mobile-menu-link"
             onClick={() => handleNavigate("/")}
          >
            Home
          </Link>

          <Link
            to="/about-us"
            className="mobile-menu-link"
           onClick={() => handleNavigate("/about-us")}
          >
            About
          </Link>

          {categories.map((cat) => (
            <div key={cat._id} className="mobile-category">
              <Link
                to={`/categories/${cat.slugPath}`}
                className="mobile-menu-link "
               onClick={() => handleNavigate(`/categories/${cat.slugPath}`)}
              >
                {cat.name}
              </Link>

              {cat.children?.length > 0 && (
                <div className="ps-3">
                  {cat.children.map((sub) => (
                    <Link
                      key={sub._id}
                      to={`/categories/${sub.slugPath}`}
                      className="mobile-submenu-link"
                      onClick={() => handleNavigate(`/categories/${sub.slugPath}`)}
                    >
                      {sub.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          <Link
            to="/shop"
            className="mobile-menu-link"
             onClick={() => handleNavigate("/shop")}
          >
            Shop
          </Link>
           <Link
            to="/blog"
            className="mobile-menu-link"
            onClick={() => handleNavigate("/blog")}
          >
           Blog
          </Link>
          <Link
            to="/contact-us"
            className="mobile-menu-link"
           onClick={() => handleNavigate("/contact-us")}
          >
            Contact Us
          </Link>
        </div>
      </div>


      {/* Mobile Search Bar */}
<div className="custom-search-bar-sec-b-mobile d-lg-none">
  <div className="custom-search-bar-sec-b-wrapper custom-search-bar-sec-b-wrapper-desktop">
    <input
      type="text"
      placeholder="Search ..."
      className="custom-search-bar-sec-b-input"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />

    <Search
      size={18}
      className="custom-search-bar-sec-b-icon"
    />
  </div>
</div>
    </>
  );
}

export default Header;
